<template>
    <div>
        <b-form @submit.prevent="saveTypeOfDanger()" data-vv-scope="formTypeOfDanger">
            <b-row>
                <b-col cols="12">
                    <b-form-group>
                        <label>Nombre <span class="text-danger">*</span></label>
                        <b-form-textarea v-model="typeOfDanger.name" type="text" class="form-control" name="name"
                            v-validate="'required'" data-vv-as=" " />
                        <span class="text-danger small" v-text="errors.first('formTypeOfDanger.name')" />
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <b-form-group>
                        <label>Prioridad <span class="text-danger">*</span></label>
                        <b-form-input v-model="typeOfDanger.priority" type="text" class="form-control" name="priority"
                            v-validate="'required'" data-vv-as=" " />
                        <span class="text-danger small" v-text="errors.first('formTypeOfDanger.priority')" />
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <b-form-group>
                        <label class="w-100">Color <span class="text-danger">*</span></label>
                        <el-color-picker v-model="typeOfDanger.color" name="color" v-validate="'required'"
                            data-vv-as=" " class="w-100 color-picker" />
                        <span class="text-danger small" v-text="errors.first('formTypeOfDanger.color')" />
                    </b-form-group>
                </b-col>

                <b-col md="12" v-if="hasValidLanguages">
                    <b-list-group>
                        <b-list-group-item v-for="language in typeOfDanger.sga_type_of_danger_languages"
                            :key="language.id" v-if="language.sga_language.code !== 'ES'">
                            <div class="d-flex align-items-center">
                                <div class="flex-grow-1">
                                    <span class="fw-bold">
                                        <input v-model="language.value" type="text"
                                            class="form-control form-control-sm w-100" />
                                    </span>
                                </div>
                                <div class="ms-auto ml-2">
                                    <b-badge variant="primary">{{ language.sga_language.code }}</b-badge>
                                    <span class="text-muted"> - {{ language.sga_language.name }}</span>
                                </div>
                            </div>
                        </b-list-group-item>
                    </b-list-group>
                </b-col>

                <b-col md="12" class="mt-3 d-flex justify-content-end align-items-center">
                    <b-form-group>
                        <b-button variant="danger" @click="cancelTypeOfDanger">
                            <i class="fa fa-reply"></i>
                            <span class="ml-1" v-text="'Cancelar'"></span>
                        </b-button>
                        <b-button type="submit" variant="primary" class="mx-1">
                            <i class="fa fa-save"></i>
                            <span class="ml-1" v-text="'Guardar'"></span>
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-form>

    </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
export default {
    name: 'FormVersions',

    computed: {
        ...mapState('sgaTypesOfDangers', ['typeOfDanger', 'action']),
        ...mapState('sgaVersions', ['activeVersions', 'activeGlobalVersion']),

        hasValidLanguages() {
            return Array.isArray(this.typeOfDanger.sga_type_of_danger_languages) &&
                this.typeOfDanger.sga_type_of_danger_languages.length > 0;
        },
    },

    created() {
        this.setTypeOfDangerSga({ ...this.typeOfDanger, version_id: this.activeGlobalVersion });
    },

    methods: {
        ...mapActions('sgaTypesOfDangers', ['createTypeOfDangerSga', 'getTypeOfDangersSga', 'updateTypeOfDangerSga']),
        ...mapActions('sgaVersions', ['getActiveVersionsSga']),
        
        ...mapMutations('sgaTypesOfDangers', ['setDefaultTypeOfDangerSga', 'setTypeOfDangerSga']),
        ...mapMutations('sgaVersions', ['setActiveGlobalVersion']),

        cancelTypeOfDanger() {
            this.setDefaultTypeOfDangerSga();
            this.$bvModal.hide('modal_create_typeOfDanger');
        },

        async cancelAndGetTypeOfDanger() {
            this.cancelTypeOfDanger();
            await this.getTypeOfDangersSga();
        },

        async saveTypeOfDanger() {
            const isValid = await this.$validator.validateAll('formTypeOfDanger');
            if (!isValid) return;

            let flag = false;
            if (this.action === 'edit') {
                flag = await this.updateTypeOfDangerSga(this.typeOfDanger);
            } else {
                flag = await this.createTypeOfDangerSga(this.typeOfDanger);
            }

            if (flag) {
                this.cancelAndGetTypeOfDanger();
            }
        },

        onHandleChangeVersion(edition) {
            this.setActiveGlobalVersion(edition)
        }

    }
}
</script>
